import { render, staticRenderFns } from "./MediaPlanBuilder.vue?vue&type=template&id=fa0fc23e&"
import script from "./MediaPlanBuilder.vue?vue&type=script&lang=ts&"
export * from "./MediaPlanBuilder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports